import { cnBem } from '@carnica/utils';
import lightTheme from "../styles/color/light-palette.pcss";
import darkTheme from "../styles/color/dark-palette.pcss";
import lightThemeV2 from "../styles/colorV2/light-palette.pcss";
import darkThemeV2 from "../styles/colorV2/dark-palette.pcss";
var lightThemeMap = {
  v1: lightTheme,
  v2: lightThemeV2
};
var darkThemeMap = {
  v1: darkTheme,
  v2: darkThemeV2
};
var getCn = function getCn(theme) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'v1';
  var map = theme === 'dark' ? darkThemeMap : lightThemeMap;
  return cnBem("theme-".concat(theme), map[version]);
};
export var cnTheme = function cnTheme(theme, version) {
  return getCn(theme, version)();
};